import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/dribbble': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8C119.3 8 8 119.3 8 256S119.3 504 256 504 504 392.7 504 256 392.7 8 256 8zM420 122.4C449.5 158.4 467.3 204.3 467.8 254.3 460.8 252.8 390.8 238.6 320.3 247.5 314.6 233.5 309.1 221.1 301.7 205.9 380 173.9 415.5 128.4 420 122.4zM396.4 97.9C392.6 103.3 360.7 146.2 285.4 174.4 250.7 110.6 212.2 58.2 206.4 50.4 273.5 34.2 344.3 51.7 396.4 97.9zM165.9 64.6C171.5 72.3 209.4 124.7 244.5 187.1 145.4 213.4 58.1 213.1 48.6 212.9 62.4 147.2 106.7 92.6 165.9 64.6zM44.2 256.3C44.2 254.2 44.2 252 44.3 249.8 53.5 250 156.2 251.4 262 219.7 268 231.6 273.8 243.6 279.2 255.7 202.6 277.2 133 339.2 98.6 398 64.8 360.4 44.2 310.7 44.2 256.3zM126 423.4C148.1 378.2 208.2 319.8 293.6 290.7 323.3 368 335.6 432.7 338.7 451.3 270.6 480.3 188.7 472.4 126 423.4zM374.4 431.9C372.2 419 360.9 357 333.2 280.9 399.6 270.3 457.9 287.7 465.2 289.9 455.7 348.9 421.9 399.8 374.4 431.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/dribbble.js
// module id = /oOB
// module chunks = 144